import baseReport from '../baseReport';
import Meses from '@/utils/dias';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarTableHeader = (data, indicaanoletivoexcedeu = 'N') => {
  let mesAnterior = '';

  return [
    [
      {
        text: 'Alunos',
        alignment: 'center',
        margin: [0, 7, 0, 0],
        rowSpan: 2,
        style: 'tableHeader',
      },
      ...data.map((key) => {
        if (key.mes !== mesAnterior) {
          mesAnterior = key.mes;
          return {
            //text: Meses.mesesMin[key.mes - 1],
            text: indicaanoletivoexcedeu === 'S' ? `${Meses.mesesMin[key.mes - 1]}\n${key.ano}` : Meses.mesesMin[key.mes - 1],
            alignment: 'center',
            colSpan: data.filter(n => n.mes === key.mes).length,
            bold: true,
            style: 'tableHeader2',
          };
        }
        return {};
      }),
    ],
    [
      '',
      //(Henrique) ...data.map(key => ({ text: key.dia, alignment: 'center', style: 'tableHeader' })),
      ...data.map(key => ({ text: key.dia, alignment: 'center', fontSize: 6, margin: [-4, 0, -4, 0], style: 'tableHeader' })),
    ],
  ];
};

const registroFrequenciaSalaAulaAnalitico = async ({ date, time, filtros, data, periodos, periodo, professores, tipoDeEnsino, indicaanoletivoexcedeu = 'N' }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Registro de Frequência Analítico - Sala de Aula' }, 'landscape');

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador:   ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:   ', bold: true },
            filtros.aaletivo,
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma:   ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina,
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Período:   ', bold: true },
            filtros.periodo,
          ],
        },
      ],
    },
  ];

  if (data.alunos.length <= 0 || data.aulas.length <= 0) {
    return {
      ...headerFooter,
      content: [{
        text: 'Nenhuma frequência encontrada.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

  let periodosFiltered = periodos;
  periodosFiltered.shift();
  if (periodo !== '-1') { periodosFiltered = periodosFiltered.filter(key => key.value === periodo); }

  const dataFormated = periodosFiltered.map((key, index) => {
    const frequencia = [];
    //(Henrique) const aulasPeriodo = data.aulas.filter(f => f.cdpravadi === key.value);
    // eslint-disable-next-line no-restricted-syntax
    /**************************************************Adicionado Inicio: Bloco inserido*/
    // O Código abaixo cria a função chunkArray - Que quebra um array em n arrays, conforme o nº de elementos desejado- por array -

    /**
    * Returns an array with arrays of the given size.
    *
    * @param myArray {Array} Array to split
    * @param chunkSize {Integer} Size of every group
    */
    function chunkArray(myArray, chunk_size){
      var results = [];

      while (myArray.length) {
          results.push(myArray.splice(0, chunk_size));
      }

      return results;
    }

    const aulasPeriodo = chunkArray(data.aulas.filter(f => f.cdpravadi === key.value), 70);
    for (let i in aulasPeriodo){
      frequencia.push(new Array())  //Cria um n arrays - frequencia0,frequencia1 para receber frequencia
    /************************************************** fim: Bloco inserido */

      for (const aluno of data.alunos) {
        const linha = [
        // aluno.nmaluno,
       // `${aluno.nmaluno}${(aluno.situacao_fim)? ` - ${aluno.situacao_fim.dssitalun}` : ''}`,
        `${aluno.nmaluno}\nDt Enturmação: ${formatDataBR(aluno.dtsitalun)}${(aluno.situacao_fim)? ` - ${aluno.situacao_fim.dssitalun}` : ''}` +
        `${(aluno.dtafastam)? ` - ${formatDataBR(aluno.dtafastam)}` : ''}`,
         ...aulasPeriodo[i].map(() => ''),
        ];
        frequencia[i].push(linha);
      }
    }
    //if (frequencia[0].length <= 0 || frequencia[0] == undefined) { return {}; }
    if (frequencia[0] == undefined || frequencia[0] == null ) { return {}; }
    if (frequencia[0].length <= 0) { return {}; }
//*****************************Inserido por Ailson - Inicio */
    let relFreqAula = [];
    /* refFreqAula[] - Será utilzado no For abaixo, para concatenar todos os dados(arrays aulas e frequencias) que compoem o relatório de frequencia*/
    for (let i in aulasPeriodo) {
      relFreqAula.push(
        {
          margin: [0, 10, 0, 0],
          fontSize: 7,
          table: {
            widths: [
              { width: '*' },
              ...aulasPeriodo[i].map(() => ({ width: '0.13%' })), //alterado de 'auto' para '0.13%'
            ],
            headerRows:2,
            dontBreakRows: true,
            body: [
              ...montarTableHeader(aulasPeriodo[i], indicaanoletivoexcedeu),
              ...frequencia[i],
            ],
          },
          pageBreak: 'after',
        },)
      }
    //*****************************Inserido por Ailson - Fim */
    return [
      {
        text: `Período Avaliativo: ${key.text}`,
        alignment: 'center',
        bold: true,
        margin: [0, 10, 0, 0],
        fontSize: 10,
      },
      ...relFreqAula
    ];
  });

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
      {
        fontSize: 9,
        italics: true,
        margin: [0, 20, 0, 0],
        text: [
          { text: 'Obs.: ', bold: true },
           (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ?
           'Este rel. apresenta todas as aulas cadastradas correspondente a campos de experência/etapa escolar para apuração de frequência. Não tem valor de documento!':
           'Este rel. apresenta todas as aulas cadastradas correspondente a disciplina/etapa escolar para apuração de frequência. Não tem valor de documento!'
          ,
        ],
      },
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
      },
      tableHeader2: {
        bold: true,
        fontSize: 8,
        color: "black",
        fillColor: "#eeeeee"
      }
    },
  };
};

export default registroFrequenciaSalaAulaAnalitico;
